<template>
     <div class="friend-get-friend">
        <div class="text-stroke-orange font-bold text-big text-white tracking-[-0.408px] " :text="lbl.get_friend.friend.toUpperCase() ">{{ lbl.get_friend.friend.toUpperCase() }}</div>
        <div class="text-stroke-orange font-semibold text-medium text-white tracking-[-0.408px]" :text="lbl.get_friend.get.toUpperCase() ">{{  lbl.get_friend.get.toUpperCase()  }}</div>
        <div class="text-stroke-orange font-bold text-big text-white tracking-[-0.408px]" :text=" lbl.get_friend.friend.toUpperCase() ">{{ lbl.get_friend.friend.toUpperCase() }}</div>
    </div>
</template>
<script>
import Locale from '@/helper/locale/locale.js';
export default {
    name: 'FriendGetFriend',
    computed: {

    },
    data: function () {
        return {
            lbl: Locale.getLbl(),
        };
    },
    created: function () {

    },
    methods: {

    }
}
</script>


<style lang="scss" scoped>
@import '@/style/base/base.scss';

.friend-get-friend{
    display:flex;
    align-items: center;
    justify-content: center;
    gap:16px;
}


.text-big{
    font-size:36px;
    font-weight: 700;
}

.text-medium{
    font-size:28px;
    font-weight: 600;
}

.text-small{
    font-size:20px;
    font-weight: 600;
}


.text-stroke-orange{
    position:relative;
    &::before {
        content:attr(text);
        position:absolute;
        -webkit-text-stroke-width:5px;
        -webkit-text-stroke-color:#FF7300;
        left:0;
        z-index:-1;
    }
    &::after {
        content:attr(text);
        position:absolute;
        -webkit-text-stroke-width:8px;
        -webkit-text-stroke-color:#FF7300;
        left:0;
        z-index:-2;
    }
}
</style>
